export enum DashboardReportType {
  OutstandingChecks = 1,
  PoliciesNotIssued = 2,
  EscrowOverdue = 3,
  NonZeroLedgerBalances = 4,
  PoliciesToSend = 5,
  PolicyIssues = 6,
  Deposits = 7,
  ExcessRecordingFunds = 8
}
